<template>
    <div v-if="accordionObj.length != 0" class="accordion">
        <div class="accordion-col">
            <AccordionItem v-for="(item, i) in leftColObj" :key="i" :accordionHeader="item.qustion" >
                <p v-html="item.answer"></p>
            </AccordionItem>
        </div>
        <div class="accordion-col">
            <AccordionItem v-for="(item, i) in rightColObj" :key="i" :accordionHeader="item.qustion" >
                <p v-html="item.answer"></p>
            </AccordionItem>
        </div>
    </div>
</template>
<script>
    import AccordionItem from '../../Accordion/AccordionItem.vue'

    export default {
        name: 'Accordion',
        components: { AccordionItem },
        props:{
            accordionObj: {type: Array, default: () => { return []; }},
        },
        data(){return{
            leftColObj: [],
            rightColObj: [],
        }},
        mounted(){
            let objLgh = this.accordionObj.length;
            for(let i = 0; i <= objLgh - 1; i++){
                // (i % 2 == 0) ?  this.leftColObj.push(this.accordionObj[i]) : this.rightColObj.push(this.accordionObj[i])
                (objLgh / 2 > i) ?  this.leftColObj.push(this.accordionObj[i]) : this.rightColObj.push(this.accordionObj[i])
            }
        },
    }
</script>
<style lang="scss" scoped>
    .accordion{

        @include respond-to(large){
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;

            & > *{ flex-basis: calc((100% / 2) - 1rem)}
        }
    }
</style>